// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  gap: var(--layout-column-gap, 1rem);
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-layout/column/column.component.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,mCAAA;AACJ","sourcesContent":[":host\n    display: flex\n    flex-direction: column\n    gap: var(--layout-column-gap, 1rem)\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
